import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import MapPage from "@/pages/MapPage";
import Profile from "@/pages/Profile";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import About from "@/pages/About";
import AuthCallback from "@/pages/AuthCallback";
import Store from "@/pages/Store";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Explorer from "@/pages/Explorer";
import PublicProfile from "@/pages/PublicProfile";
import GamesHub from "@/pages/GamesHub";
import NearbyGame from "@/pages/NearbyGame";
import AlienZombies from "@/pages/AlienZombies";
import GamesLeaderboard from "@/pages/GamesLeaderboard";
import GamesTeams from "@/pages/GamesTeams";
import GamesFriends from "@/pages/GamesFriends";
import GamesProfile from "@/pages/GamesProfile";
import MoonExplorer from "@/pages/MoonExplorer";
import { LangProvider } from "@/lib/lang";
import { AuthProvider } from "@/lib/auth";
import { CartProvider } from "@/lib/cart";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/map" element={<MapPage />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/about" element={<About />} />
      <Route path="/store" element={<Store />} />
      <Route path="/explorer" element={<Explorer />} />
      <Route path="/user/:username" element={<PublicProfile />} />
      <Route path="/games" element={<GamesHub />} />
      <Route path="/games/nearby" element={<NearbyGame />} />
      <Route path="/games/alien-zombies" element={<AlienZombies />} />
      <Route path="/games/leaderboard" element={<GamesLeaderboard />} />
      <Route path="/games/teams" element={<GamesTeams />} />
      <Route path="/games/friends" element={<GamesFriends />} />
      <Route path="/games/profile" element={<GamesProfile />} />
      <Route path="/moon-explorer" element={<MoonExplorer />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/order/:orderNumber" element={<OrderSuccess />} />
    </Routes>
  );
}

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AppRouter />
          <Toaster
            theme="light"
            position="top-center"
            toastOptions={{
              style: {
                background: "rgba(255,255,255,0.98)",
                border: "1px solid rgba(24,24,27,0.1)",
                color: "#18181b",
                backdropFilter: "blur(20px)",
              },
            }}
          />
        </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
